// このファイルは apps/web/scripts/build_deck.mjs が作ります。手で直さないこと。
/** 画数ブラックジャックの札。小学校で習う漢字を画数ごとに分けたもの。 */
export const BJ_DECK: Readonly<Record<number, string>> = {
  1: '一',
  2: '人十二九入力八七刀丁',
  3: '大三上子下小山女川千口土夕工万丸才弓士久亡己干寸',
  4: '日中月五手円六文水木天火王犬分内方今公午心元引少止切太戸友父毛牛化区予反氏不夫欠支比仏収片仁尺',
  5: '本出生四立目田正石白右左玉市外用北半台広古母冬兄矢代主平世打由仕去写申他央号皮礼氷皿民以加必付辺',
  6: '年気百先名早字竹休耳虫糸会同自行地合回米当多交考西毎光色羽池寺肉全安向次死両式有州守曲血列羊成共',
  7: '見男村町車足花赤貝社言体来作近売何声形谷図走角里弟麦汽対決投住局役身究助医返坂君豆改初告利別求位',
  8: '金学空青林雨国長東明京画知直店門夜歩岩妹姉事者定実表取和受委物使所始放育味命注岸苦具油波幸服板昔',
  9: '音草後前首思点活海計食南科室風春秋星昼茶発相度持県指界面重品係急送研神乗待追負美客屋昭洋級秒柱畑',
  10: '校時高通家記書原帰紙馬夏弱員院島真流消配宮起病速根倍旅庭庫息酒勉荷連案特挙料害席残差候殺航帯徒笑',
};
